import React, { useState } from "react";
import { Modal, SubmitButton, TextComponent } from "../../../../components";
import styles from "./ViewStaffProfile.module.css";
import { RiDeleteBin6Line } from "react-icons/ri";
import editUser from "../../../../assets/images/editUser.png";
import { AiOutlineQuestionCircle } from "react-icons/ai";
import { PiSealCheck } from "react-icons/pi";
import avatar from "../../../../assets/images/dummy.png";
import { FaSquareCheck } from "react-icons/fa6";
import { FaRegSquare } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { AuthMiddleware } from "../../../../Store/Middlewares/AuthMiddleware";
import { phoneFormat } from "../../../../utills";
const ViewStaffProfile = ({
  viewStafffProfile,
  setViewStaffProfile,
  details,
  setDetails,
  setEditStaffModal,
}) => {
  const dispatch = useDispatch();
  const [deleteModal, setDeleteModal] = useState(false);
  const [success, setSuccess] = useState(false);
  const user = useSelector((state) => state.AuthReducer.user);

  return (
    <div>
      <Modal
        width={"600px"}
        open={viewStafffProfile}
        onCancel={() => {
          setViewStaffProfile(false);
          setDetails([]);
        }}
      >
        <div className={styles.mainCont}>
          <img
            src={details?.profile_picture ? details?.profile_picture : avatar}
            className={styles.profileImg}
          />
          <TextComponent text={details?.name || ""} className={styles.name} />
          <TextComponent text={details?.role || ""} className={styles.role} />
          <TextComponent
            text={details?.contact_no ? phoneFormat(details?.contact_no) : ""}
          />
          <TextComponent text={details?.email || ""} />
          <div className={styles.perList}>
            {details?.permissions?.map((item, index) => (
              <div className={styles.perListItem}>
                {item?.is_access == 1 ? (
                  <FaSquareCheck color="var(--secondary-color)" size={18} />
                ) : (
                  <FaRegSquare color="var(--secondary-color)" size={18} />
                )}
                <TextComponent
                  className={styles.perText}
                  text={
                    item?.name == "action_for_immobilizer"
                      ? "Action For Immobilizer"
                      : item?.name == "add_asset"
                        ? "Add Vehicle"
                        : item?.name == "group_immobilizer"
                          ? "Lot lockdown control"
                          : item?.name == "temporary_access"
                            ? "Temporary Access"
                            : item?.name == "sell_through"
                              ? "Sell Through"
                              : item?.name == "reports"
                                ? "Reports"
                                : item?.name == "staff_creation"
                                  ? "Staff Creation"
                                  : item?.name == "pair_unpair_device"
                                    ? "Pair/Unpair Device"
                                    : item?.name == "lot_name"
                                      ? "Lot Name"
                                      : ""
                  }
                />
              </div>
            ))}
          </div>
          <div
            className={styles.button}
            onClick={() => setViewStaffProfile(false)}
          >
            <SubmitButton title={"Go Back"} secondaryBtn />
          </div>
          <div className={styles.editDeleteBox}>
            {details?.id !== user?.id && user?.role !== "owner" && (
              <RiDeleteBin6Line
                className={styles.editDeleteIcon}
                color={"var(--primary-color)"}
                onClick={() => setDeleteModal(true)}
              />
            )}

            <img
              src={editUser}
              className={styles.editDeleteIcon}
              onClick={() => {
                setEditStaffModal(true);
                setViewStaffProfile(false);
              }}
            />
          </div>
        </div>
      </Modal>
      <Modal
        open={deleteModal}
        onCancel={() => {
          setDeleteModal(false);
        }}
        icon={
          <AiOutlineQuestionCircle
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        twoButton
        okBtnTitle={"Yes, Remove"}
        cancelBtnTitle={"No, go back"}
        title={"Are you sure"}
        text={"You want to remove this user?"}
        width={400}
        // btnDiv={styles.access_modalBtn}
        onClickCancelButton={() => {
          setDeleteModal(false);
        }}
        onClickOkButton={() => {
          dispatch(AuthMiddleware.deleteStaff({ id: details?.id })).then(() => {
            setSuccess(true);
            setDeleteModal(false);
            setViewStaffProfile(false);
          });
        }}
        headingClass={styles.modalHeading}
      ></Modal>
      <Modal
        open={success}
        onCancel={() => setSuccess(false)}
        icon={
          <PiSealCheck
            style={{ width: "100%", height: "100%", objectFit: "contain" }}
          />
        }
        title={"User removed"}
        width={"400px"}
        buttonTitle={"Continue"}
        onBtnPress={() => {
          setSuccess(false);
        }}
        headingClass={styles.modalHeading}
      ></Modal>
    </div>
  );
};

export default ViewStaffProfile;
